import {ApplicationModalStep} from "../types/ApplicationModalStep";
import {IApplicationData} from "../types/IApplicationData";
import {IApplicationReducerData} from "../types/IApplicationReducerData";
import {ApplicationModalStateEvent, IApplicationModalStateContext, resolveNextStep} from "./application_modal_state_transitions";

export interface IApplicationModalStateData {
    originalApplicationResponse: IApplicationData | null;
    recommendationsWithPriceFilter: boolean;
    leadData: IApplicationReducerData | null;
}

export interface IApplicationModalState {
    step: ApplicationModalStep;
    context: IApplicationModalStateContext;
    data: IApplicationModalStateData;
}

type ISendEventAction = {
    type: "sendEvent";
    event: ApplicationModalStateEvent;
    dataUpdates?: Partial<IApplicationModalStateData>;
    contextUpdates?: Partial<IApplicationModalStateContext>;
};

type IUpdateContextAction = {
    type: "updateContext";
    context: Partial<IApplicationModalStateContext>;
};

type IUpdateDataAction = {
    type: "updateData";
    data: Partial<IApplicationModalStateData>;
};

export type ApplicationModalStateAction = ISendEventAction | IUpdateContextAction | IUpdateDataAction;

export const initialApplicationModalState: IApplicationModalState = {
    step: ApplicationModalStep.WAITING,
    context: {
        isMultileadEnabled: false,
        needsMarketingConsent: false,
        needsHomeMatchBasicPreferences: false,
        isAutoresponderEnabled: false,
        forceClose: false
    },
    data: {
        originalApplicationResponse: null,
        recommendationsWithPriceFilter: false,
        leadData: null
    }
};

export const applicationModalStateReducer = (state: IApplicationModalState, action: ApplicationModalStateAction): IApplicationModalState => {
    switch (action.type) {
        case "sendEvent": {
            const mergedContext = action.contextUpdates ? {...state.context, ...action.contextUpdates} : state.context;
            const nextStep = resolveNextStep(state.step, action.event, mergedContext);

            if (nextStep === null) {
                return state;
            }

            const nextData = action.dataUpdates ? {...state.data, ...action.dataUpdates} : state.data;

            if (nextStep === ApplicationModalStep.CLOSE) {
                return {...initialApplicationModalState, step: ApplicationModalStep.CLOSE};
            }

            return {...state, step: nextStep, context: mergedContext, data: nextData};
        }
        case "updateContext": {
            return {...state, context: {...state.context, ...action.context}};
        }
        case "updateData": {
            return {...state, data: {...state.data, ...action.data}};
        }
        default: {
            return state;
        }
    }
};
import {ApplicationModalStep} from "../types/ApplicationModalStep";
import {IApplicationData} from "../types/IApplicationData";
import {IApplicationReducerData} from "../types/IApplicationReducerData";
import {ApplicationModalStateEvent, IApplicationModalStateContext, resolveNextStep} from "./application_modal_state_transitions";

export interface IApplicationModalStateData {
    originalApplicationResponse: IApplicationData | null;
    recommendationsWithPriceFilter: boolean;
    leadData: IApplicationReducerData | null;
}

export interface IApplicationModalState {
    step: ApplicationModalStep;
    context: IApplicationModalStateContext;
    data: IApplicationModalStateData;
}

type ISendEventAction = {
    type: "sendEvent";
    event: ApplicationModalStateEvent;
    dataUpdates?: Partial<IApplicationModalStateData>;
    contextUpdates?: Partial<IApplicationModalStateContext>;
};

type IUpdateContextAction = {
    type: "updateContext";
    context: Partial<IApplicationModalStateContext>;
};

type IUpdateDataAction = {
    type: "updateData";
    data: Partial<IApplicationModalStateData>;
};

export type ApplicationModalStateAction = ISendEventAction | IUpdateContextAction | IUpdateDataAction;

export const initialApplicationModalState: IApplicationModalState = {
    step: ApplicationModalStep.WAITING,
    context: {
        isMultileadEnabled: false,
        needsMarketingConsent: false,
        needsHomeMatchBasicPreferences: false,
        isAutoresponderEnabled: false,
        forceClose: false
    },
    data: {
        originalApplicationResponse: null,
        recommendationsWithPriceFilter: false,
        leadData: null
    }
};

export const applicationModalStateReducer = (state: IApplicationModalState, action: ApplicationModalStateAction): IApplicationModalState => {
    switch (action.type) {
        case "sendEvent": {
            const mergedContext = action.contextUpdates ? {...state.context, ...action.contextUpdates} : state.context;
            const nextStep = resolveNextStep(state.step, action.event, mergedContext);

            if (nextStep === null) {
                return state;
            }

            const nextData = action.dataUpdates ? {...state.data, ...action.dataUpdates} : state.data;

            if (nextStep === ApplicationModalStep.CLOSE) {
                return {...initialApplicationModalState, step: ApplicationModalStep.CLOSE};
            }

            return {...state, step: nextStep, context: mergedContext, data: nextData};
        }
        case "updateContext": {
            return {...state, context: {...state.context, ...action.context}};
        }
        case "updateData": {
            return {...state, data: {...state.data, ...action.data}};
        }
        default: {
            return state;
        }
    }
};
